import { ChatbotSidebarState } from './interfaces';
import { handleActions } from 'redux-actions';
import { includes } from 'lodash';
import {
  RESET_MENU,
  SET_IS_MINIMIZED,
  SetIsMinimizedAction,
  TOGGLE_MENU_GROUP_EXPANDED,
  ToggleMenuGroupExpandedAction,
} from './actions';

const initialState: ChatbotSidebarState = {
  isMinimized: false,
  expandedMenuGroups: [],
};

const setIsMinimized = (
  state: ChatbotSidebarState,
  action: any,
): ChatbotSidebarState => {
  const { isMinimized } = action as SetIsMinimizedAction;

  return {
    ...state,
    isMinimized,
  };
};

const toggleMenuGroupExpanded = (
  state: ChatbotSidebarState,
  action: any,
): ChatbotSidebarState => {
  const { menuGroupId } = action as ToggleMenuGroupExpandedAction;

  const isExpanded = includes(state.expandedMenuGroups, menuGroupId);
  const expandedMenuGroups = isExpanded ? [] : [menuGroupId];

  return {
    ...state,
    expandedMenuGroups,
  };
};

const resetMenu = (state: ChatbotSidebarState): ChatbotSidebarState => ({
  ...state,
  expandedMenuGroups: [],
});

const mappedReducers = {
  [SET_IS_MINIMIZED]: setIsMinimized,
  [TOGGLE_MENU_GROUP_EXPANDED]: toggleMenuGroupExpanded,
  [RESET_MENU]: resetMenu,
};

const chatbotSidebarState = handleActions(mappedReducers, initialState);

export default chatbotSidebarState;
